import { createNamespace, Actions } from "../../../../../../flux";
import { ActionType, BatchAction } from "./VehicleBatchEditStore";
import { GroupActionsFn, PressureLevels, TemperatureLevels } from "../../../../../../rest/GroupAction";
import { Timezone, Quantities, Unit } from "../../../../../../rest/Misc";

import { assertValue } from "../../../../../utils/assert/index";
import { ListActions } from "../../../../../flux/Grid/ListActions";

const ns = createNamespace('VehicleGroupActions')
export const names = {
    REJECT_DRAFT: ns('REJECT_DRAFT'),
    
    SET_IDS: ns('SET_IDS'),
    SET_AXLE_COUNT: ns('SET_AXLE_COUNT'),
    SET_ALL_TAGS: ns('SET_ALL_TAGS'),
    SET_AVAILABLE_TAGS_STAT: ns('SET_AVAILABLE_TAGS_STAT'),
    SELECT_ACTION: ns('SELECT_ACTION'),
    
    SET_SELECTED_TAGS: ns('SET_SELECTED_TAGS'),
    SET_TIMEZONE: ns('SET_TIMEZONE'),
    
    SET_UNIT: ns('SET_UNIT'),
    SET_AXLE: ns('SET_AXLE'),
    SET_BASELINE: ns('SET_BASELINE'),
    SET_DEFINE_ALERT_LEVELS_FLAG: ns('SET_DEFINE_ALERT_LEVELS_FLAG'),
    SET_RED_MAX: ns('SET_RED_MAX'),
    SET_RED_MIN: ns('SET_RED_MIN'),
    SET_YELLOW_MAX: ns('SET_YELLOW_MAX'),
    SET_YELLOW_MIN: ns('SET_YELLOW_MIN'),
    
    COMMIT_ACTION: ns('COMMIT_ACTION'),
    REMOVE_ACTION: ns('REMOVE_ACTION'),
};

export class VehicleBatchEditActions extends Actions
{
    private readonly listActions = new ListActions();

    setIds = (ids: (number| string)[]) => this.dispatch(names.SET_IDS, ids);
    setAxleCount = (axleCount: number) => this.dispatch<number>(names.SET_AXLE_COUNT, axleCount);
    setAllTags = (tags: string[]) => this.dispatch(names.SET_ALL_TAGS, tags);
    setAvailableTagsStat = (tagsStat: Map<string, number>) => this.dispatch(names.SET_AVAILABLE_TAGS_STAT, tagsStat);    
    setActionType = (type: ActionType) => this.dispatch(names.SELECT_ACTION, type);
    setTags = (tags: string[]) => this.dispatch(names.SET_SELECTED_TAGS, tags);
    setTimezone = (tz: Timezone) => this.dispatch(names.SET_TIMEZONE, tz);
    setAxle = (axle: number) => this.dispatch(names.SET_AXLE, axle);
    setBaseline = (value: number) => this.dispatch(names.SET_BASELINE, value);
    setDefineAlertLevelsFlag = (flag: boolean) => this.dispatch(names.SET_DEFINE_ALERT_LEVELS_FLAG, flag);
    setRedMax = (value: number) => this.dispatch(names.SET_RED_MAX, value);
    setYellowMax = (value: number) => this.dispatch(names.SET_YELLOW_MAX, value);
    setYellowMin = (value: number) => this.dispatch(names.SET_YELLOW_MIN, value);
    setRedMin = (value: number) => this.dispatch(names.SET_RED_MIN, value);
    setUnit = (unit: Unit) => this.dispatch(names.SET_UNIT, unit);
    
    commitAction = () => this.dispatch(names.COMMIT_ACTION);
    removeAction = (id: string) => this.dispatch(names.REMOVE_ACTION, id);

    rejectDraft = () => this.dispatch(names.REJECT_DRAFT);
}


// WEBPACK FOOTER //
// ./src/app/components/Pages/Vehicle/BatchEdit/flux/VehicleBatchEditActions.ts